import { MenuProduct } from '../MenuProduct';

export class MenuProductMapper {
  public static toDomain = (dto: CoreServiceAPI.ProductDto): MenuProduct => ({
    productNumber: dto.productNumber,
    productName: dto.nameExtra ? `${dto.displayName} ${dto.nameExtra}` : dto.displayName
  });
}
